{
  "settings": "설정",
  "yourDigitalAssistant": "챗봇",
  "getStarted": "시작하기",
  "login": "로그인",
  "loggingIn": "로그인 ...",
  "darkMode": "야간 모드",
  "clearHistory": "대화 내용 삭제",
  "historyCleared": "대화 내용이 삭제되었습니다",
  "changeLanguage": "언어",
  "termsAndConditions": "약관",
  "messagePlaceholder": "메세지를 여기에 입력하세요 ...",
  "messagePlaceholderDisabled": "입력 할 수 없습니다 ...",
  "feedbackTitle": "평가",
  "feedbackPlaceholder": "그것에 대해 알려주십시오 (선택 사항)",
  "feedbackSend": "보내다",
  "feedbackClose": "닫다",
  "sessionExpired": "사용이 없어 세션이 만료되었습니다.",
  "startNewSession": "새로운 세션 시작",
  "apiError": "죄송합니다! 문제가 발생했습니다. 가능한 빨리 해결할수 있도록 노력하고 있습니다.",
  "apiErrorOffline": "인터넷에 연결되어 있지 않습니다.",
  "tryAgain": "다시 시도해 주세요 ",
  "startOver": "다시 시도해 주세요 ",
  "chatEnded": "채팅이 종료되었습니다.",
  "chatEndedThankYou": "저희와 채팅 해주셔서 감사합니다!",
  "closeChat": "닫기",
  "startNewChat": "다시 채팅",
  "humanTakeoverStarted": "직원에게 연결 중 입니다.",
  "humanTakeoverQueued": "직원에게 연결하기 위해 대기 중 입니다.",
  "humanTakeoverAnAgent": "직원",
  "humanTakeoverAgentEntered": "대화방에 들어왔습니다.",
  "humanTakeoverAgentLogout": "대화방을 나갔습니다.",
  "humanTakeoverTransfer": "다른 직원에게 연결 중 입니다.",
  "humanTakeoverEnded": "현재 챗봇과 대화 중 입니다",
  "version": "버전",
  "formIntroText": "채팅을 시작하려면 다음 양식을 작성하십시오.",
  "formFirstName": "이름",
  "formLastName": "성",
  "formName": "이름",
  "formEmail": "이메일",
  "formWrongEmail": "유효한 이메일 주소를 입력하십시오.",
  "formPhone": "전화",
  "formShipmentId": "배송 ID",
  "formQuestion": "당신의 질문",
  "formAccountNumber": "계좌 번호 (비즈니스 고객 용)",
  "formAddress": "주소",
  "formPostcode": "우편번호",
  "formCity": "시티",
  "formCountry": "국가",
  "formSubmitButton": "채팅 시작",
  "formEmptyFieldError": "빈칸은 허용하지 않습니다.",
  "formPhoneNumberValidationError": "유효한 전화 번호가 아닙니다.",
  "formInputIsBiggerThan50": "최대 50 자 이하만 작성 가능합니다.",
  "formInputIsBiggerThan100": "최대 100 자 이하만 작성 가능합니다.",
  "formInputIsBiggerThan2000": "최대 2000 자 이하만 작성 가능합니다.",
  "widgetEventOnline": "DA 메시지 : 사용자가 온라인 상태입니다.",
  "widgetEventHidden": "DA 메시지 : 위젯이 숨겨져 있습니다.",
  "widgetEventVisible": "DA 메시지 : 위젯이 표시됩니다.",
  "widgetEventVisibleMinimized": "DA 메시지 : 위젯이 표시되지만 최소화되었습니다.",
  "widgetEventMinimized": "DA 메시지 : 위젯이 최소화되었습니다.",
  "widgetEventMaximized": "DA 메시지 : 위젯이 최대화되었습니다.",
  "widgetEventSessionExpired": "DA 메시지 : 위젯 세션이 만료되었습니다.",
  "widgetEventHangupHuman": "DA 메시지: 사용자가 인적 인수 세션을 종료합니다.",
  "widgetEventUserTyping": "DA 메시지 : 사용자가 입력 중입니다.",
  "fileTooLarge": "너무 큰 파일을 첨부하려고합니다.",
  "tooManyDiles": "너무 많은 파일을 첨부하려고합니다.",
  "fileInvalidType": "잘못된 파일 형식을 첨부하려고합니다.",
  "attachmentsDropHere": "업로드하려면 여기에 드롭하거나",
  "attachmentsBrowse": "파일 찾아보기",
  "attachmentsExtenstionQuantity": "pdf 또는 이미지 (최대 10 개 파일)",
  "attachmentsSize": "최대 30MB",
  "attachmentsFailedUploading": "업로드 실패",
  "attachmentsUploading": "업로드 중 ...",
  "minimizeExpandText": "지금 우리와 실시간 채팅을 하세요!",
  "popupWidgetNotificationMessage": "새 메시지를 받았습니다!",
  "tabWidgetNotificationMessage": "새로운 메시지!",
  "datepickerSendButton": "전송된"
}
